import { render, staticRenderFns } from "./modalSortTable.vue?vue&type=template&id=33bbba19&"
import script from "./modalSortTable.vue?vue&type=script&lang=js&"
export * from "./modalSortTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports